<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-before: always;"></div>
<h1 class="P_Heading_1__And__Page_Break" id="auto_bookmark_toc_1"><span>Acknowledgments</span></h1>
<p class="P_Normal"> </p>
<p class="P_Normal"> </p>
<p class="P_Normal__And__Left_Indent"><span style=" font-size: 1.17em;">THANKS FIRST</span> and foremost to Dan Cullinan, who put up with ten million medical questions and was the only reason I was able to say, “Yes, I can do a medical trilogy.”</p>
<p class="P_Normal">Thank you to Tracy Cheuk and to the commenters on the Formosa forums, who kindly helped me make Hong-Wei more accurate and gave me insight into his life.</p>
<p class="P_Normal">Thank you to Anna Cullinan and her mad mapmaking skills, which not only made Copper Point feel more real, but kept me from sending people in ten different directions.</p>
<p class="P_Normal">Thank you to Elizabeth North for helping me dream up Copper Point and giving it a home at Dreamspinner Press.</p>
<p class="P_Normal">Thank you to my patrons who kept me company as I drafted this work, who peeked at early drafts, and as always gave me the life and love I needed to keep going. Thank you especially to Rosie M, Pamela Bartual, Marie, and Sarah Plunkett.</p>
<p class="P_Normal">Thank you to my readers, whether you have just found me or have been along for the ride for all ten years. Let’s make stories for thirty more.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section-0004.vue?a1f164de